import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ERROR_CODES, KeyValue } from '../../types/common.types';
import { ACTION_TYPES } from '../../constants/actions';
import { navigate } from 'gatsby';
import { navigation } from '../../middlewares/navigation-constants';
import { openTargetUrlAsync } from '../../helpers/common';
import { ekycActions } from '@detox/actions';

export const useEkycInit = (): void => {
  const dispatch = useDispatch();
  const { ekycState } = useSelector((state: KeyValue) => ({
    ekycState: state.ekyc
  }));
  useEffect(() => {
    const { ekycFlag, url } = ekycState?.initEkycpayload || {};
    if (ekycFlag) {
      dispatch({
        type: ACTION_TYPES.EKYC.EKYC_INITIALIZATION_SUCCESS,
        value: { initEkycpayload: null }
      });
      if (ekycFlag === 'true' && url) {
        openTargetUrlAsync(url);
      } else if (ekycFlag === 'false') {
        navigate(`/${navigation.CHECKOUT}`, { replace: true });
      }
    } else if (
      ekycState?.isInitEkycError ||
      ekycState?.initEkycpayload === ERROR_CODES.ERROR_RESPONSE
    ) {
      navigate(`/${navigation.ERROR}`, { replace: true });
    }
  }, [ekycState?.initEkycpayload, ekycState?.isInitEkycError]);
};

export const useVerifyEkyc = (): void => {
  const dispatch = useDispatch();
  const { ekycState } = useSelector((state: KeyValue) => ({
    ekycState: state.ekyc
  }));

  useEffect(() => {
    // Early exit if not eligible for EKYC
    dispatch(ekycActions.verifyEkycWithEshop());
  }, []);

  useEffect(() => {
    const { ekycFlag } = ekycState?.verifyEkycPayload || {};

    if (ekycState?.isVerifyEkycError || (ekycFlag && ekycFlag === 'true')) {
      navigate(`/${navigation.ERROR}`, { replace: true });
    }
  }, [ekycState?.verifyEkycPayload?.ekycFlag, ekycState?.isVerifyEkycError]);
};

export const useMcssVerifyEkyc = (): void => {
  const dispatch = useDispatch();
  const { ekycState } = useSelector((state: KeyValue) => ({
    ekycState: state.ekyc
  }));

  useEffect(() => {
    // Early exit if not eligible for EKYC
    dispatch(ekycActions.verifyEkycWithMcss());
  }, []);

  useEffect(() => {
    const verifyEkycMcssPayload = ekycState?.verifyEkycPayload || {};
    const isCustomerExists = verifyEkycMcssPayload?.customerExists;
    if (ekycState?.isVerifyEkycError || isCustomerExists === false) {
      navigate(`/${navigation.ERROR}`, { replace: true });
    }
  }, [
    ekycState?.verifyEkycPayload?.customerExists,
    ekycState?.isVerifyEkycError
  ]);
};
